import { HisInformationItem } from ".";

export class HisInformationItemSet {
  constructor(public items: HisInformationItem[]) {
  }
}
